(() => {
  if (window.__tbwProductPreviewInitialized) return;
  window.__tbwProductPreviewInitialized = true;
  const bound = new WeakSet();

  function initialize(scope = document) {
    scope.querySelectorAll('[data-tbw-preview]').forEach(preview => {
      if (bound.has(preview)) return;
      bound.add(preview);
      const owner = preview.closest('section[id^="MainProduct-"]');
      const desktopSlot = owner?.querySelector('[data-tbw-preview-slot="desktop"]');
      const mobileSlot = owner?.querySelector('[data-tbw-preview-slot="mobile"]');
      const model = preview.querySelector('model-viewer');
      const activate = preview.querySelector('[data-preview-activate]');
      const label = preview.querySelector('[data-preview-label]');
      const status = preview.querySelector('[data-preview-status]');
      const controls = preview.querySelector('[data-preview-controls]');
      const choice = preview.querySelector('[data-preview-choice]');
      const poster = preview.querySelector('.tbw-product-preview__poster');
      if (!desktopSlot || !mobileSlot || !model || !activate) return;
      const mobile = window.matchMedia('(max-width: 749px)');
      const place = () => {
        const slot = mobile.matches ? mobileSlot : desktopSlot;
        if (preview.parentElement !== slot) slot.appendChild(preview);
      };
      place();
      mobile.addEventListener('change', place);
      let loadTimer;
      let activated = false;
      let attempts = 0;

      function fail() {
        if (preview.dataset.state === 'poster') return;
        clearTimeout(loadTimer);
        preview.dataset.state = 'error';
        activate.removeAttribute('aria-disabled');
        activate.hidden = false;
        controls.querySelectorAll('button').forEach(button => { button.disabled = true; });
        model.tabIndex = -1;
        model.setAttribute('aria-hidden', 'true');
        model.setAttribute('inert', '');
        label.textContent = 'Try 3D Preview Again';
        status.textContent = '3D preview unavailable. Please retry.';
      }

      model.addEventListener('load', async event => {
        if (!activated || preview.dataset.state !== 'loading') return;
        if (event.detail?.url && new URL(event.detail.url, document.baseURI).href !== new URL(preview.dataset.modelUrl, document.baseURI).href) return;
        const loadedAttempt = attempts;
        const loadedUrl = preview.dataset.modelUrl;
        const focusRequested = document.activeElement === activate;
        const stillCurrent = () => activated && preview.dataset.state === 'loading' && loadedAttempt === attempts && loadedUrl === preview.dataset.modelUrl;
        await new Promise(resolve => requestAnimationFrame(resolve));
        if (!stillCurrent()) return;
        model.cameraOrbit = preview.dataset.cameraOrbit;
        model.cameraTarget = preview.dataset.cameraTarget;
        model.fieldOfView = preview.dataset.fieldOfView;
        await new Promise(resolve => requestAnimationFrame(resolve));
        if (!stillCurrent()) return;
        model.jumpCameraToGoal();
        clearTimeout(loadTimer);
        preview.dataset.state = 'ready';
        activate.hidden = true;
        activate.removeAttribute('aria-disabled');
        controls.querySelectorAll('button').forEach(button => { button.disabled = false; });
        model.tabIndex = 0;
        model.removeAttribute('aria-hidden');
        model.removeAttribute('inert');
        status.textContent = '3D preview ready.';
        if (focusRequested && document.activeElement === activate) model.focus();
      });
      model.addEventListener('error', fail);

      choice?.addEventListener('change', () => {
        const selected = choice.selectedOptions[0];
        if (!selected) return;
        ++attempts;
        clearTimeout(loadTimer);
        activated = false;
        preview.dataset.state = 'poster';
        model.src = '';
        model.tabIndex = -1;
        model.setAttribute('aria-hidden', 'true');
        model.setAttribute('inert', '');
        controls.querySelectorAll('button').forEach(button => { button.disabled = true; });
        for (const key of ['modelUrl', 'cameraOrbit', 'cameraTarget', 'fieldOfView', 'orientation']) preview.dataset[key] = selected.dataset[key];
        model.minCameraOrbit = selected.dataset.minCameraOrbit;
        model.maxCameraOrbit = selected.dataset.maxCameraOrbit;
        model.cameraOrbit = selected.dataset.cameraOrbit;
        model.cameraTarget = selected.dataset.cameraTarget;
        model.fieldOfView = selected.dataset.fieldOfView;
        model.orientation = selected.dataset.orientation;
        model.alt = `Interactive 3D model of ${selected.dataset.modelLabel}`;
        poster.src = selected.dataset.posterUrl;
        poster.alt = `Rendered 3D view of ${selected.dataset.modelLabel}`;
        activate.setAttribute('aria-label', `Activate interactive 3D preview for ${selected.dataset.modelLabel}`);
        activate.removeAttribute('aria-disabled');
        activate.hidden = false;
        label.textContent = 'View Interactive 3D Model';
        status.textContent = 'Selected model ready to activate.';
      });

      activate.addEventListener('click', async () => {
        if (preview.dataset.state === 'loading' || preview.dataset.state === 'ready') return;
        const requestAttempt = ++attempts;
        preview.dataset.state = 'loading';
        activate.setAttribute('aria-disabled', 'true');
        label.textContent = 'Loading 3D Preview…';
        status.textContent = 'Loading 3D preview.';
        loadTimer = setTimeout(fail, 30000);
        await customElements.whenDefined('model-viewer');
        if (preview.dataset.state !== 'loading' || requestAttempt !== attempts) return;
        activated = true;
        if (requestAttempt > 1) {
          model.src = '';
          await new Promise(resolve => requestAnimationFrame(resolve));
          if (preview.dataset.state !== 'loading' || requestAttempt !== attempts) return;
        }
        model.src = preview.dataset.modelUrl;
      });

      preview.querySelectorAll('[data-preview-zoom]').forEach(button => {
        button.addEventListener('click', () => {
          const orbit = model.getCameraOrbit();
          const factor = Number(button.dataset.previewZoom) > 0 ? 0.88 : 1 / 0.88;
          model.cameraOrbit = `${orbit.theta}rad ${orbit.phi}rad ${orbit.radius * factor}m`;
          model.jumpCameraToGoal();
        });
      });
      preview.querySelector('[data-preview-reset]').addEventListener('click', () => {
        model.cameraOrbit = preview.dataset.cameraOrbit;
        model.cameraTarget = preview.dataset.cameraTarget;
        model.fieldOfView = preview.dataset.fieldOfView;
        model.jumpCameraToGoal();
      });
      if (choice) choice.disabled = false;
      activate.disabled = false;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
